"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { getToken } from "@/lib/api";
import { captureReferral } from "@/lib/referralAttribution";

/** Pages a referral link never redirects away from (sign-up itself, sign-in, the affiliate portal, the app). */
const STAY = /^\/(signup|login|forgot-password|affiliate|dashboard|impersonate)(\/|$)/;

/** Captures ?aff / ?ref from the URL on every navigation and counts affiliate visits. Someone arriving through a
 *  referral link who isn't signed in goes straight to sign-up (older links pointed at the home page); the code is
 *  stored first, so the sign-up is credited. */
export function ReferralCapture() {
  const pathname = usePathname();
  const router = useRouter();
  useEffect(() => {
    const found = captureReferral();
    if (found && !STAY.test(pathname || "/") && !getToken()) router.replace("/signup");
  }, [pathname, router]);
  return null;
}
